/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/scheduleList.config.json";
import sam_config from "../config/schedule.config.json";
import sam_sections from "../config/sections.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_SCHEDULE_LIST } from "../graphql";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
//@ts-ignore
import { v4 as uuidv4 } from "uuid";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GET_BANDS_WITH_SECTIONS } from "../graphql/bandsWithSections.query";
import { pretty } from "@vlinder-web/utils-react";

const storageService = StorageModule.getInstance();

const log: any = LoggerModule.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const storageSrv = StorageModule.getInstance();

export interface IScheduleListMethods extends IPluginMethodMap {
  getScheduleList(args: any): Promise<any>;
}

export class ScheduleListService implements IAgentPlugin {
  readonly methods: IScheduleListMethods;

  constructor() {
    this.methods = {
      getScheduleList: this.getScheduleList.bind(this),
    };
  }

  async getScheduleList(args: any) {
    log.blue(`getScheduleList service : `, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_SCHEDULE_LIST,
          variables: {
            filter: {
              ...args?.criteria,
              band__in: [storageService.get("bandConfig", "local")?.band?.appCardId ?? null]
            },
            getDistCentsFilter: {
              band__in: [storageService.get("bandConfig", "local")?.band?.appCardId ?? null]
            }
          },
          fetchPolicy: "network-only",
        });

        const bandsWithSections = await client.query({
          query: GET_BANDS_WITH_SECTIONS,
          variables: {
            filter: {
              _id: storageService.get("bandConfig", "local")?.band?.appCardId
            }
          },
          fetchPolicy: "network-only",
        })
        console.log("bandsWithSections", pretty(bandsWithSections))
        const allSections = bandsWithSections?.data?.getBandWithSection?.sections;
        console.log("all sections===>", pretty(allSections))
        if (res?.data) {
          // console.log("all sections===>", pretty(res?.data))
          return {
            schedules: res?.data?.getSchedules?.content,
            sectionData: allSections,
            eventsData: this._getSchedules(res?.data?.getSchedules?.content),
            isEmpty: res?.data?.getSchedules?.content?.length <= 0,
            distCenters: this._getOptions(res?.data?.getDistCents?.content),
            eventFields: this.getEventFields(
              config.EVENTS_FIELDS,
              res?.data?.getDistCents?.content,
              allSections
            ),
            layout: config.LAYOUT,
          };
        }
      }
    } catch (err: any) {
      log.error(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private _getSchedules = (data: any) => {
    let _res: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        console.log(`schedule item : `, item);
        _res.push({
          id: uuidv4(),
          title: item?.name,
          scheduleID: item?.scheduleID,
          start: item?.eventStartTime,
          end: item?.eventEndTime,
          distributionCenter: item?.distCent?.id,
          allowedMasqueraders: item?.maxAttendees,
          vipOnly: item?.vipOnly === true ? "yes" : "no",
          isPublished: item?.isPublished,
          description: item?.description,
          createdAt: item?.createdAt,
          className:
            item?.isPublished && item?.isPaused
              ? "bg-warning border-0 shadow"
              : item?.isPublished && item?.maxAttendees === item?.attendeesCount
                ? "bg-primary border-0 shadow"
                : item?.isPublished
                  ? "bg-danger border-0 shadow"
                  : "",
          attendeesCount: item?.attendeesCount,
          isPaused: item?.isPaused,
          sectionValue: item?.sections,
          sectionOptTypeValue: item?.newSectionOptTypes,
        });
      });
    console.log(`_getSchedules : `, _res);
    return _res;
  };

  private getEventFields = (fields: any, distCenters: any, section?: any) => {
    let _res: any = [];
    const sessionData = storageSrv.get("bandConfig", "local");
    log.blue(`sessionData : `, section, "fields :", fields);

    if (fields && Array.isArray(fields) && fields.length > 0) {
      fields.map((item: any) => {
        if (item?.key === "distributionCenter") {
          _res.push({
            ...item,
            compProps: {
              ...item?.compProps,
              options: this._getDistOptions(distCenters),
            },
          });
        }
        else {
          _res.push(item);
        }
      });
    }
    return _res;
  };

  private _getDistOptions = (data: any) => {
    let _res: any[] = [];
    if (data && Array.isArray(data) && data.length > 0) {
      data.map((item: any, index: number) => {
        _res.push({
          label: item?.name ? item?.name : item?.distCenterId,
          id: item?.id,
        });
      });
    }
    return _res;
  };

  private _getOptions = (data: any) => {
    log.blue(`_getOptions : `, data);
    let _res: any[] = [];
    if (data && Array.isArray(data) && data.length > 0) {
      data.map((item: any, index: number) => {
        _res.push({
          label: item,
          id: item,
        });
      });
    }
    return _res;
  };
}
